// utils/seoTags.js
import React from "react";
import { useStaticQuery, graphql } from "gatsby";

export const Head = ({
  data,
  location,
  title,
  description,
  image: imageProp,
  robots,
  jsonLd,
}) => {
  // Fallback automático al siteUrl si no viene en props.data
  const staticQuery = useStaticQuery(graphql`
    query {
      site {
        siteMetadata {
          siteUrl
        }
      }
    }
  `);

  const siteUrl =
    data?.site?.siteMetadata?.siteUrl || staticQuery.site.siteMetadata.siteUrl;

  const page = data?.strapiPage || data?.strapiZona || {};

  const finalTitle = title || page.meta_title || page.title || "";
  const finalDescription = description || page.meta_description || "";
  const pathname = location?.pathname || "/";
  const url = `${siteUrl}${pathname}`;
  const image = imageProp || page.cover?.url || null;
  const robotsContent = robots || page.robots;

  return (
    <>
      <html lang="es" />
      <title>{finalTitle}</title>
      <meta name="description" content={finalDescription} />
      {robotsContent && robotsContent.toLowerCase() !== "index, follow" && (
        <meta name="robots" content={robotsContent.toLowerCase()} />
      )}
      <meta property="og:title" content={finalTitle} />
      <meta property="og:description" content={finalDescription} />
      <meta property="og:type" content="website" />
      <meta property="og:url" content={url} />
      {image && <meta property="og:image" content={image} />}
      <link rel="canonical" href={url} />
      {jsonLd && (
        <script type="application/ld+json">{JSON.stringify(jsonLd)}</script>
      )}
    </>
  );
};
